import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { userClearState } from 'reducers/user/reducer'
import UserList from './UserList'
import UserItem from './UserItem'
import './style.scss'

function User(props) {
  const {
    match: {
      params: { id },
    },
    userClearState,
  } = props
  const UserContent = id ? UserItem : UserList

  useEffect(
    () => () => {
      userClearState()
    },
    [],
  )

  return (
    <div className="content">
      <UserContent {...props} />
    </div>
  )
}

User.propTypes = {
  applications: PropTypes.array.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  userClearState: PropTypes.func.isRequired,
}

export default connect(
  state => ({
    applications: state.getIn(['profile', 'profile', 'applications']).toArray(),
  }),
  {
    userClearState,
  },
)(User)
